import {
  ObjectEx
} from "vue-objectex";

const initUniversities = () => {
  let id = 1;
  let basicData = ["SFU", "UBC", "UTM", "UTSG", "UTSC"]; //"YORK",
  const resultData = new ObjectEx(basicData.map(item => {
    let basicOption = {
      key: item,
      value: id++
    };

    let pictures = [];
    switch (item) {
      case "SFU":
        pictures.push(
          "SFU校区.png",
          "SFU教室_1.png",
          "SFU教室_2.png",
          "SFU教室_3.png"
        );
        break;
      case "UBC":
        pictures.push(
          "UBC校区.png",
          "UBC教室_1.png",
          "UBC教室_2.png",
          "UBC教室_3.png"
        );
        break;
      case "UTM":
        pictures.push(
          "UTM校区.png",
          "UTM教室_1.png",
          "UTM教室_2.png",
          "UTM教室_3.png"
        );
        break;
      case "UTSG":
        pictures.push(
          "UTSG校区.png",
          "UTSG教室_1.png",
          "UTSG教室_2.png",
          "UTSG教室_3.png"
        );
        break;
      // case "YORK":
      //   pictures.push(
      //     "YORK校区.png",
      //     "YORK教室 _1.png",
      //     "YORK教室 _2.png",
      //     "YORK教室 _3.png"
      //   );
      //   break;
      case "UTSC":
        pictures.push(
          "UTSC校区.png",
          "UTSC教室_1.png",
          "UTSC教室_2.png",
          "UTSC教室_3.png"
        );
        break;
    }
    basicOption.pictures = pictures;

    return basicOption;
  }));

  return resultData;
};
const universities = initUniversities();

const initSpecialities = () => {
  const resultData = new ObjectEx([], {
    addOptions(university, basicData) {
      let universityOption = universities.valueOf(university);
      if (!universityOption)
        throw new Error("university not exist.");

      if (Object.typeOf(basicData) !== "array")
        throw new Error("basicData is not an array.");

      let index = this.getOptions().length;
      basicData.forEach(item => {
        let key = `${universityOption.key}_${item.key}`;
        if (!!this.keyOf(key))
          return;

        item.key = key;
        item.value = ++index;
        item.university = universityOption.value;
        this.addOption(item);
      });
    },
    getSpecialitiesByUniversity(university) {
      let enumOptions = this.getOptions().filter(item => item.university === university);
      return enumOptions;
    }
  });

  {
    let basicData = [{
      key: "BUS",
      desc: "Business Administration",
      abbr: "BUS",
    }, {
      key: "CHEM",
      desc: "Chemistry",
      abbr: "CHEM",
    }, {
      key: "CMNS",
      desc: "Coumnication",
      abbr: "CMNS",
    }, {
      key: "CMPT",
      desc: "Computer Science",
      abbr: "CMPT",
    }, {
      key: "ECON",
      desc: "Economics",
      abbr: "ECON",
    }, {
      key: "LING",
      desc: "Linguistic",
      abbr: "LING",
    }, {
      key: "MATHAndMACM",
      desc: "Mathematics/Mathematics",
      abbr: "MATH/MACM",
    }, {
      key: "STAT",
      desc: "Statistics",
      abbr: "STAT",
    }, {
      key: "OART",
      desc: "其他文科课程",
      abbr: "其他文科课程",
    }, {
      key: "OSCI",
      desc: "其他理科课程",
      abbr: "其他理科课程",
    }];
    resultData.addOptions(universities.SFU, basicData);
  }

  {
    let basicData = [{
      key: "BIOL",
      desc: "Biology",
      abbr: "BIOL",
    }, {
      key: "COMM",
      desc: "Commerce",
      abbr: "COMM",
    }, {
      key: "ECON",
      desc: "Economics",
      abbr: "ECON",
    }, {
      key: "EOSC",
      desc: "Earth and Ocean Science",
      abbr: "EOSC",
    }, {
      key: "MATH",
      desc: "Mathematics",
      abbr: "MATH",
    }, {
      key: "CPSC",
      desc: "Computer Science",
      abbr: "CPSC",
    }, {
      key: "CHEM",
      desc: "Chemistry",
      abbr: "CHEM",
    }, {
      key: "PHIL",
      desc: "Philosophy",
      abbr: "PHIL",
    }, {
      key: "PHYS",
      desc: "Physics",
      abbr: "PHYS",
    }, {
      key: "PSYC",
      desc: "Psychology",
      abbr: "PSYC",
    }, {
      key: "STAT",
      desc: "Statistics",
      abbr: "STAT",
    }, {
      key: "OTH",
      desc: "其他课程",
      abbr: "其他课程",
    }];
    resultData.addOptions(universities.UBC, basicData);
  }

  {
    let basicData = [{
      key: "ANT",
      desc: "Anthropology",
      abbr: "ANT",
    }, {
      key: "CCIT",
      desc: "Communication, Culture, Information and Technology",
      abbr: "CCIT",
    }, {
      key: "CSC",
      desc: "Computer Science",
      abbr: "CSC",
    }, {
      key: "ECO",
      desc: "Economics",
      abbr: "ECO",
    }, {
      key: "ENV",
      desc: "Environment",
      abbr: "ENV",
    }, {
      key: "FSL",
      desc: "French",
      abbr: "FSL",
    }, {
      key: "GGR",
      desc: "Geography",
      abbr: "GGR",
    }, {
      key: "JALAndLIN",
      desc: "Linguistics",
      abbr: "JAL & LIN",
    }, {
      key: "MAT",
      desc: "Mathematics",
      abbr: "MAT",
    }, {
      key: "MGMAndMGT",
      desc: "Management",
      abbr: "MGM/MGT",
    }, {
      key: "PHL",
      desc: "Philosophy",
      abbr: "PHL",
    }, {
      key: "PHY",
      desc: "Physics",
      abbr: "PHY",
    }, {
      key: "JPEAndPOL",
      desc: "Political Science",
      abbr: "JPE & POL",
    }, {
      key: "SOC",
      desc: "Sociology",
      abbr: "SOC",
    }, {
      key: "STA",
      desc: "Statistics",
      abbr: "STA",
    }, {
      key: "OART",
      desc: "其他文科",
      abbr: "其他文科",
    }];
    resultData.addOptions(universities.UTM, basicData);
  }

  {
    let basicData = [{
      key: "BIO",
      desc: "Biology",
      abbr: "BIO",
    }, {
      key: "CSC",
      desc: "Computer Science",
      abbr: "CSC",
    }, {
      key: "ECO",
      desc: "Economics",
      abbr: "ECO",
    }, {
      key: "LIN",
      desc: "Linguistics",
      abbr: "LIN",
    }, {
      key: "MAT",
      desc: "Mathematics",
      abbr: "MAT",
    }, {
      key: "PHL",
      desc: "Philosophy",
      abbr: "PHL",
    }, {
      key: "PHY",
      desc: "Physics",
      abbr: "PHY",
    }, {
      key: "RSM",
      desc: "Rotman Commerce",
      abbr: "RSM",
    }, {
      key: "STA",
      desc: "Statistics",
      abbr: "STA",
    }, {
      key: "OART",
      desc: "其他文科",
      abbr: "OART",
    }, {
      key: "OSCI",
      desc: "其他理科",
      abbr: "其他理科",
    }];
    resultData.addOptions(universities.UTSG, basicData);
  }

  // {
  //   let basicData = [{
  //     key: "ADMS",
  //     desc: "Administrative Studies",
  //     abbr: "ADMS",
  //   }, {
  //     key: "ECON",
  //     desc: "Economics",
  //     abbr: "ECON",
  //   }, {
  //     key: "EECS",
  //     desc: "Electrical Engineering and Computer Science",
  //     abbr: "EECS",
  //   }, {
  //     key: "ITEC",
  //     desc: "Information Technology",
  //     abbr: "ITEC",
  //   }, {
  //     key: "NATS",
  //     desc: "Natural Science",
  //     abbr: "NATS",
  //   }, {
  //     key: "SOSC",
  //     desc: "Social Science",
  //     abbr: "SOSC",
  //   }, {
  //     key: "OSCI",
  //     desc: "其他理科",
  //     abbr: "其他理科",
  //   }];
  //   resultData.addOptions(universities.YORK, basicData);
  // }

  {
    let basicData = [{
      key: "BIO",
      desc: "BIology",
      abbr: "BIO",
    }, {
      key: "CHM",
      desc: "Chemistry",
      abbr: "CHM",
    }, {
      key: "CIT",
      desc: "City Studies",
      abbr: "CIT",
    }, {
      key: "CSC",
      desc: "Computer Science",
      abbr: "CSC",
    }, {
      key: "EES",
      desc: "Environmental Science",
      abbr: "EES",
    }, {
      key: "LIN",
      desc: "Linguistics",
      abbr: "LIN",
    }, {
      key: "MAT",
      desc: "Mathematics",
      abbr: "MAT",
    }, {
      key: "MDS",
      desc: "Media Studies",
      abbr: "MDS",
    }, {
      key: "MGAll",
      desc: "Managemant",
      abbr: "MGA/MGE/MGF/MGH/MGO/MGT",
    }, {
      key: "PSY",
      desc: "Psychology",
      abbr: "PSY",
    }, {
      key: "STA",
      desc: "Statistics",
      abbr: "STA",
    }, {
      key: "OSCI",
      desc: "其他理科",
      abbr: "其他理科",
    }];
    resultData.addOptions(universities.UTSC, basicData);
  }

  return resultData;
};
const specialities = initSpecialities();

const initCourses = () => {
  const resultData = new ObjectEx([], {
    addOptions(speciality, basicData) {
      let specialityOption = specialities.valueOf(speciality);
      if (!specialityOption)
        throw new Error("speciality not exist.");

      if (Object.typeOf(basicData) !== "array")
        throw new Error("basicData is not an array.");

      let universityOption = universities.valueOf(specialityOption.university);
      if (!universityOption)
        throw new Error("university not exist.");

      let index = this.getOptions().length;
      basicData.forEach(item => {
        let key = `${universityOption.key}_${item}`;
        if (!!this.keyOf(key))
          return;

        let enumOption = {
          key,
          value: ++index,
          name: item,
          speciality: specialityOption.value
        };
        this.addOption(enumOption);
      });
    },
    getCoursesBySpeciality(speciality) {
      let enumOptions = this.getOptions().filter(item => item.speciality === speciality);
      return enumOptions;
    }
  });

  {
    let universityKey = "SFU";

    let basicData = ["BUS200", "BUS207", "BUS216", "BUS217", "BUS232", "BUS233", "BUS237", "BUS251", "BUS254", "BUS272", "BUS303", "BUS312", "BUS315", "BUS316", "BUS320", "BUS321", "BUS336", "BUS343", "BUS360", "BUS381", "BUS393", "BUS410", "BUS418"];
    resultData.addOptions(specialities[`${universityKey}_BUS`], basicData);

    basicData = ["CHEM110", "CHEM120", "CHEM121"];
    resultData.addOptions(specialities[`${universityKey}_CHEM`], basicData);

    basicData = ["CMNS110", "CMNS130"];
    resultData.addOptions(specialities[`${universityKey}_CMNS`], basicData);

    basicData = ["CMPT120", "CMPT125", "CMPT130", "CMPT165", "CMPT225", "CMPT120", "CMPT125", "CMPT130", "CMPT135", "CMPT165", "CMPT225", "CMPT295"];
    resultData.addOptions(specialities[`${universityKey}_CMPT`], basicData);

    basicData = ["ECON103", "ECON105", "ECON201", "ECON220", "ECON260", "ECON280", "ECON290", "ECON291", "ECON302", "ECON305", "ECON310", "ECON325", "ECON331", "ECON333", "ECON342", "ECON345", "ECON355", "ECON381", "ECON383", "ECON387", "ECON392", "ECON410", "ECON425", "ECON460"];
    resultData.addOptions(specialities[`${universityKey}_ECON`], basicData);

    basicData = ["LING100", "LING110", "LING111", "LING160", "LING200", "LING200", "LING220", "LING220"];
    resultData.addOptions(specialities[`${universityKey}_LING`], basicData);

    basicData = ["MACM101", "MACM201", "MACM316", "MATH100", "MATH104", "MATH150", "MATH151", "MATH151", "MATH152", "MATH152", "MATH157", "MATH158", "MATH232", "MATH251", "MATH310"];
    resultData.addOptions(specialities[`${universityKey}_MATHAndMACM`], basicData);

    basicData = ["STAT100", "STAT201", "STAT203", "STAT203", "STAT260", "STAT270", "STAT270", "STAT285", "STAT302", "STAT302", "STAT305", "STAT452", "STAT475", "STAT485"];
    resultData.addOptions(specialities[`${universityKey}_STAT`], basicData);

    basicData = ["CA104", "CRIM101", "CRIM135", "ENGL112", "ENGL115", "FPA104", "FREN120", "FREN121", "GEOG100", "GEOG111", "JAP100", "JAP101", "PHIL100", "PHIL105", "PHIL110", "PHIL120", "PSYC100", "PSYC102", "PSYC109"];
    resultData.addOptions(specialities[`${universityKey}_OART`], basicData);

    basicData = ["PHYS100", "PHYS120", "SCI300", "BISC101"];
    resultData.addOptions(specialities[`${universityKey}_OSCI`], basicData);
  }

  {
    let universityKey = "UBC";

    let basicData = ["BIOL111", "BIOL112", "BIOL121", "BIOL155", "BIOL200"];
    resultData.addOptions(specialities[`${universityKey}_BIOL`], basicData);

    basicData = ["COMM101", "COMM204", "COMM205", "COMM290", "COMM291", "COMM293", "COMM294", "COMM295", "COMM296", "COMM298", "COMM370", "COMM371", "COMM393", "COMM398", "COMM457"];
    resultData.addOptions(specialities[`${universityKey}_COMM`], basicData);

    basicData = ["ECON101", "ECON102", "ECON221", "ECON301", "ECON302", "ECON315", "ECON317", "ECON325", "ECON326", "ECON327", "ECON345", "ECON355", "ECON356", "ECON370", "ECON371", "ECON374", "ECON390", "ECON425", "ECON471", "ECON472"];
    resultData.addOptions(specialities[`${universityKey}_ECON`], basicData);

    basicData = ["EOSC114", "EOSC116", "EOSC118"];
    resultData.addOptions(specialities[`${universityKey}_EOSC`], basicData);

    basicData = ["MATH100", "MATH102", "MATH104", "MATH184", "MATH200", "MATH210", "MATH215", "MATH220", "MATH221", "MATH300", "MATH302", "MATH303", "MATH307", "MATH308", "MATH312", "MATH316", "MATH317", "MATH320", "MATH322", "MATH340", "MATH341"];
    resultData.addOptions(specialities[`${universityKey}_MATH`], basicData);

    basicData = ["CPSC110", "CPSC121", "CPSC210", "CPSC213", "CPSC221"];
    resultData.addOptions(specialities[`${universityKey}_CPSC`], basicData);

    basicData = ["CHEM111", "CHEM121", "CHEM123", "CHEM203", "CHEM205", "CHEM208", "CHEM211", "CHEM233"];
    resultData.addOptions(specialities[`${universityKey}_CHEM`], basicData);

    basicData = ["PHIL120", "PHIL220"];
    resultData.addOptions(specialities[`${universityKey}_PHIL`], basicData);

    basicData = ["PHYS101", "PHYS117"];
    resultData.addOptions(specialities[`${universityKey}_PHYS`], basicData);

    basicData = ["PSYC101", "PSYC102", "PSYC217", "PSYC300", "PSYC301", "PSYC302", "PSYC304", "PSYC308", "PSYC313", "PSYC314", "PSYC320", "PSYC340"];
    resultData.addOptions(specialities[`${universityKey}_PSYC`], basicData);

    basicData = ["STAT200", "STAT251", "STAT300", "STAT302", "STAT305", "STAT306", "STAT344", "STAT404", "STAT406"];
    resultData.addOptions(specialities[`${universityKey}_STAT`], basicData);

    basicData = ["LING101", "GERM433"];
    resultData.addOptions(specialities[`${universityKey}_OTH`], basicData);
  }

  {
    let universityKey = "UTM";

    let basicData = ["ANT101", "ANT102"];
    resultData.addOptions(specialities[`${universityKey}_ANT`], basicData);

    basicData = ["CCT109", "CCT110", "CCT208", "CCT210", "CCT218", "CCT222", "CCT270"];
    resultData.addOptions(specialities[`${universityKey}_CCIT`], basicData);

    basicData = ["CSC108", "CSC148"];
    resultData.addOptions(specialities[`${universityKey}_CSC`], basicData);

    basicData = ["ECO100", "ECO200", "ECO202", "ECO204", "ECO209", "ECO220", "ECO344", "ECO349", "ECO358", "ECO359", "ECO364", "ECO365", "ECO370", "ECO375", "ECO435", "ECO436", "ECO460"];
    resultData.addOptions(specialities[`${universityKey}_ECO`], basicData);

    basicData = ["ENV100", "ENV201", "ENV310", "ENV311"];
    resultData.addOptions(specialities[`${universityKey}_ENV`], basicData);

    basicData = ["FSL105", "FSL106"];
    resultData.addOptions(specialities[`${universityKey}_FSL`], basicData);

    basicData = ["GGR111", "GGR112", "GGR202", "GGR209", "GGR210", "GGR214", "GGR217", "GGR227", "GGR252", "GGR272", "GGR276", "GGR277", "GGR278", "GGR305", "GGR313", "GGR316", "GGR321", "GGR335", "GGR337", "GGR370", "GGR376", "GGR382", "GGR494"];
    resultData.addOptions(specialities[`${universityKey}_GGR`], basicData);

    basicData = ["JAL253", "JAL355", "LIN101", "LIN102", "LIN204", "LIN205", "LIN208", "LIN228", "LIN229", "LIN231", "LIN232", "LIN233", "LIN256", "LIN310", "LIN325", "LIN353", "LIN380", "LIN388", "LIN476", "LIN486"];
    resultData.addOptions(specialities[`${universityKey}_JALAndLIN`], basicData);

    basicData = ["MAT102", "MAT133", "MAT135", "MAT136", "MAT202", "MAT223", "MAT224", "MAT232", "MAT236", "MAT244", "MAT301", "MAT302", "MAT311", "MAT334", "MAT337", "MAT344", "MAT402"];
    resultData.addOptions(specialities[`${universityKey}_MAT`], basicData);

    basicData = ["MGM101", "MGM102", "MGT120", "MGT220", "MGT223", "MGT224", "MGT225", "MGT231", "MGT232", "MGT252", "MGT262", "MGT270", "MGT330", "MGT338", "MGT339", "MGT353", "MGT371", "MGT374", "MGT393", "MGT430", "MGT438", "MGT491"];
    resultData.addOptions(specialities[`${universityKey}_MGMAndMGT`], basicData);

    basicData = ["PHL103", "PHL204", "PHL239", "PHL245", "PHL246", "PHL247"];
    resultData.addOptions(specialities[`${universityKey}_PHL`], basicData);

    basicData = ["PHY100", "PHY136"];
    resultData.addOptions(specialities[`${universityKey}_PHY`], basicData);

    basicData = ["JPE251", "JPE252", "POL111", "POL112"];
    resultData.addOptions(specialities[`${universityKey}_JPEAndPOL`], basicData);

    basicData = ["SOC100", "SOC109", "SOC209", "SOC244"];
    resultData.addOptions(specialities[`${universityKey}_SOC`], basicData);

    basicData = ["STA107", "STA256", "STA258", "STA260", "STA302", "STA304", "STA305", "STA310", "STA312", "STA314", "STA437", "STA457"];
    resultData.addOptions(specialities[`${universityKey}_STA`], basicData);

    basicData = ["ERS101", "JGE378"];
    resultData.addOptions(specialities[`${universityKey}_OART`], basicData);
  }

  {
    let universityKey = "UTSG";

    let basicData = ["BIO120", "BIO130"];
    resultData.addOptions(specialities[`${universityKey}_BIO`], basicData);

    basicData = ["CSC104", "CSC108", "CSC111", "CSC148", "CSC165"];
    resultData.addOptions(specialities[`${universityKey}_CSC`], basicData);

    basicData = ["ECO101", "ECO102", "ECO105", "ECO200", "ECO202", "ECO204", "ECO206", "ECO208", "ECO220", "ECO349", "ECO358", "ECO359", "ECO364", "ECO365", "ECO380"];
    resultData.addOptions(specialities[`${universityKey}_ECO`], basicData);

    basicData = ["LIN101", "LIN102", "LIN200", "LIN204", "LIN232"];
    resultData.addOptions(specialities[`${universityKey}_LIN`], basicData);

    basicData = ["MAT133", "MAT135", "MAT136", "MAT137", "MAT223", "MAT224", "MAT235", "MAT237", "MAT244", "MAT246", "MAT247", "MAT334", "MAT344"];
    resultData.addOptions(specialities[`${universityKey}_MAT`], basicData);

    basicData = ["PHL245"];
    resultData.addOptions(specialities[`${universityKey}_PHL`], basicData);

    basicData = ["PHY132", "PHY152"];
    resultData.addOptions(specialities[`${universityKey}_PHY`], basicData);

    basicData = ["RSM100", "RSM219", "RSM221", "RSM222", "RSM230", "RSM250", "RSM260"];
    resultData.addOptions(specialities[`${universityKey}_RSM`], basicData);

    basicData = ["STA130", "STA220", "STA237", "STA238", "STA257", "STA261", "STA302", "STA303", "STA304", "STA305"];
    resultData.addOptions(specialities[`${universityKey}_STA`], basicData);

    basicData = ["AST201", "ENV200", "PSY100", "SOC100"];
    resultData.addOptions(specialities[`${universityKey}_OART`], basicData);

    basicData = ["CHM136"];
    resultData.addOptions(specialities[`${universityKey}_OSCI`], basicData);
  }

  // {
  //   let universityKey = "YORK";

  //   let basicData = ["ADMS1000", "ADMS1010", "ADMS1500", "ADMS2200", "ADMS2320", "ADMS2400", "ADMS2500", "ADMS2510", "ADMS2511", "ADMS2610", "ADMS3300", "ADMS3330", "ADMS3351", "ADMS3530", "ADMS3660"];
  //   resultData.addOptions(specialities[`${universityKey}_ADMS`], basicData);

  //   basicData = ["ECON1000", "ECON1010", "ECON1530", "ECON1540", "ECON2300", "ECON2350", "ECON2400", "ECON2450", "ECON2500", "ECON3150", "ECON3200", "ECON3210", "ECON3240", "ECON3411", "ECON3430", "ECON3440", "ECON3249", "ECON3480", "ECON3500", "ECON3510", "ECON3530", "ECON3559", "ECON3569", "ECON3580", "ECON3709", "ECON3810", "ECON4010", "ECON4020", "ECON4070", "ECON4080", "ECON4130", "ECON4140", "ECON4190", "ECON4200", "ECON4400", "ECON4410"];
  //   resultData.addOptions(specialities[`${universityKey}_ECON`], basicData);

  //   basicData = ["EECS1012", "EECS1022"];
  //   resultData.addOptions(specialities[`${universityKey}_EECS`], basicData);

  //   basicData = ["ITEC1000", "ITEC1010"];
  //   resultData.addOptions(specialities[`${universityKey}_ITEC`], basicData);

  //   basicData = ["NATS1560", "NATS1740", "NATS1780", "NATS1870"];
  //   resultData.addOptions(specialities[`${universityKey}_NATS`], basicData);

  //   basicData = ["SOSC1000", "SOSC1009", "SOSC1185", "SOSC1340", "SOSC1349"];
  //   resultData.addOptions(specialities[`${universityKey}_SOSC`], basicData);

  //   basicData = ["MATH1581", "PSYC1010"];
  //   resultData.addOptions(specialities[`${universityKey}_OSCI`], basicData);
  // }

  {
    let universityKey = "UTSC";

    let basicData = ["BIOA01", "BIOA02"];
    resultData.addOptions(specialities[`${universityKey}_BIO`], basicData);

    basicData = ["CHMA10", "CHMA11"];
    resultData.addOptions(specialities[`${universityKey}_CHM`], basicData);

    basicData = ["CITB01", "CITB03"];
    resultData.addOptions(specialities[`${universityKey}_CIT`], basicData);

    basicData = ["CSCA07", "CSCA08", "CSCA20", "CSCA48", "CSCB07", "CSCB09", "CSCB20", "CSCB63", "CSCC11", "CSCC37", "CSCC63", "CSCC73"];
    resultData.addOptions(specialities[`${universityKey}_CSC`], basicData);

    basicData = ["EESA01", "EESA06", "EESA07", "EESA09", "EESA10", "EESB03", "EESB16", "EESB19", "EESB20"];
    resultData.addOptions(specialities[`${universityKey}_EES`], basicData);

    basicData = ["LINA01", "LINA02", "LINB04", "LINB06", "LINB09", "LINB10", "LINB18", "LINB20", "LINB29", "LINB60", "LINB62"];
    resultData.addOptions(specialities[`${universityKey}_LIN`], basicData);

    basicData = ["MATA22", "MATA23", "MATA30", "MATA31", "MATA32", "MATA33", "MATA36", "MATA37", "MATA67", "MATB24", "MATB41", "MATB42", "MATB43", "MATB44", "MATB61", "MATC01", "MATC15", "MATC32", "MATC34", "MATC44", "MATD01", "MATD02"];
    resultData.addOptions(specialities[`${universityKey}_MAT`], basicData);

    basicData = ["MDSA01", "MDSA02", "MDSB05", "MDSB09", "MDSB15", "MDSB61", "MDSB63"];
    resultData.addOptions(specialities[`${universityKey}_MDS`], basicData);

    basicData = ["MGAB01", "MGAB02", "MGAB03", "MGAC01", "MGEA02", "MGEA05", "MGEA06", "MGEB01", "MGEB02", "MGEB05", "MGEB06", "MGEB11", "MGEB12", "MGEC02", "MGEC06", "MGEC11", "MGEC31", "MGEC32", "MGEC34", "MGEC37", "MGEC38", "MGEC40", "MGEC41", "MGEC58", "MGEC61", "MGEC62", "MGEC71", "MGEC81", "MGEC87", "MGFB10", "MGFC10", "MGFC20", "MGFC30", "MGFD10", "MGFD30", "MGFD40", "MGFD50", "MGHB02", "MGHB12", "MGHC02", "MGMA01", "MGOC10", "MGOC20", "MGTA01", "MGTA02", "MGTA05", "MGTA35"];
    resultData.addOptions(specialities[`${universityKey}_MGAll`], basicData);

    basicData = ["PSYA01", "PSYA02", "PSYB30", "PSYB32", "PSYB38", "PSYB51", "PSYB57"];
    resultData.addOptions(specialities[`${universityKey}_PSY`], basicData);

    basicData = ["STAB22", "STAB41", "STAB52", "STAB57", "STAC32", "STAC33", "STAC50", "STAC51", "STAC53", "STAC58", "STAC62", "STAC63", "STAC67", "STAC70", "STAD29", "STAD37", "STAD57"];
    resultData.addOptions(specialities[`${universityKey}_STA`], basicData);

    basicData = ["PHYA10"];
    resultData.addOptions(specialities[`${universityKey}_OSCI`], basicData);
  }

  return resultData;
};
const courses = initCourses();

export {
  universities,
  specialities,
  courses
};

export const getVideoList = (university) => {
  let list = [];

  switch (university) {
    case universities.SFU: {
      list = [
        {
          course: 'MATH157',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/449ddbb41b1ae6cbcd/9c1e76100d6ec663" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: 'Bright'
        },
        {
          course: 'ECON103',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/d39ddbb41913eac75a/40a7fc78b9c27507" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: 'Vera'
        },
        {
          course: 'ECON105',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/ac9ddbb41913e9c725/fed5e7f38a798233" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: '沈思远'
        },
        {
          course: 'ECON201',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/119ddbb41b1ae5c998/7d3f4b949be9fbd8" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: '沈思远'
        },
        {
          course: 'BUS251 ',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/d39ddbb41b1ae3c55a/1608db233dd814a4" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: 'Alex'
        },
        {
          course: 'CMPT120',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/449ddbb41b1ae4c9cd/c192687c42dfd28e" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: '皮哥'
        },
        {
          course: 'ECON260',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/799ddbb41b1ae6c2f0/2ac2c012b94a9292" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: 'Danny'
        },
        {
          course: 'LING200',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/d39ddbb41b1ae6c05a/448e88e861d4d315" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: 'Vicky'
        },
        {
          course: 'PHIL105',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/ac9ddbb41b1ae7c225/af77d5a92c0ad23f" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: 'Paul'
        },
      ];
      break;
    }
    case universities.UBC: {
      list = [{
          course: 'ECON101',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/119ddbb41b1ae7cb98/41550b5ad6b08ecd" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: 'Mark'
        },
        {
          course: 'MATH104',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/449ddbb41b1ae7cacd/7cd79cd58e36e897" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: '俊哥'
        },
        {
          course: 'BIOL112',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/d39ddbb41b1ae8ce5a/5090b77c478396bc" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: 'Maggie'
        },
        {
          course: 'COMM205',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/ea9ddbb41b1ae5c663/3b1ac6fc7d82f5d7" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: '竺海华'
        },
        {
          course: 'COMM298',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/d39ddbb41b1ae9cf5a/6530a071a4b82999" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: 'Holly'
        },
        {
          course: 'MATH200',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/119ddbb41b1ae9c598/2bec69b8b47f5bd9" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: '老杜'
        },
        // {
        //   course: 'ECON301',
        //   video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/a79ddbb41b1ae9cb2e/de4381b18844a5d7" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
        //   teacher: 'Cathy'
        // },
        {
          course: 'BIOL121',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/ea9ddbb41913eac263/f24bc9ae3c5abab7" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: 'Maggie'
        },
      ];
      break;
    }
    case universities.UTM: {
      list = [
        // {
        //   course: 'ECO100',
        //   video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/4d9ddbb41b1be1c0c4/06df5134c9de6b34" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
        //   teacher: '陈东尔'
        // },
        // {
        //   course: 'ECO200',
        //   video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/709ddbb41b1be0c0f9/62d769b91022d480" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
        //   teacher: '陈东尔'
        // },
        // {
        //   course: 'ECO202',
        //   video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/119ddbb41b1be0cd98/a1a384cfab169f39" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
        //   teacher: '黑黑'
        // },
        {
          course: 'MAT136',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/ac9ddbb41b1be1c525/3f71ce315bbf3160" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: 'Dylan'
        },
        // {
        //   course: 'LIN101',
        //   video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/119ddbb41b1be3ce98/38713ba60933654b" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
        //   teacher: '张雪婷'
        // },
        {
          course: 'MAT223',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/799ddbb41b1be2c7f0/3923b167ca67a3ed" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: 'Julie'
        },
        {
          course: 'MGM101',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/4d9ddbb41b1be2c3c4/bf4139b5a6477adf" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: '丁然'
        },
        {
          course: 'MGT120',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/069ddbb41b1be5c38f/0ccba8d88a3bc64c" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: 'Francis'
        },
        // {
        //   course: 'STA256',
        //   video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/ea9ddbb41b1be5c763/7614adbfecf15041" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
        //   teacher: 'Crystal'
        // },
      ];
      break;
    }
    case universities.UTSG: {
      list = [{
          course: 'MAT223',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/4d9ddbb41b1be4c5c4/b2a88b4c603d577f" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: '老王'
        },
        {
          course: 'RSM219',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/449ddbb41b1be4c8cd/5f4bc14c09245976" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: 'Francis'
        },
        {
          course: 'STA220',
          video: '<div style="position:relative;height:0;padding-bottom:56.25%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/d39ddbb41b1be7c05a/88507f1d27cfa9c8" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: '老王'
        },
      ];
      break;
    }
    //case universities.YORK: 
    case universities.UTSC: {
      list = [{
          course: 'Accounting',
          video: '<div style="position:relative;height:0;padding-bottom:57.50798722044729%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/ea9ddbb51a1defcb63/2d318f92165c3b79" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: ''
        },
        {
          course: 'Communication',
          video: '<div style="position:relative;height:0;padding-bottom:57.50798722044729%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/4d9ddbb51a1deec9c4/99fd342b3f864b42" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: ''
        },
        {
          course: 'Math',
          video: '<div style="position:relative;height:0;padding-bottom:57.50798722044729%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/a79ddbb51a1ee4c22e/6054bcf0e788aa2d" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: ''
        },
        {
          course: 'Economic',
          video: '<div style="position:relative;height:0;padding-bottom:57.50798722044729%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/119ddbb51a1ee5cd98/2e50ceddaa8b2773" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: ''
        },
        {
          course: 'Finance',
          video: '<div style="position:relative;height:0;padding-bottom:57.50798722044729%"><iframe class="sproutvideo-player" src="https://videos.sproutvideo.com/embed/4d9ddbb51a1ee6c2c4/f85f064e4a74877b" style="position:absolute;width:100%;height:100%;left:0;top:0" frameborder="0" allowfullscreen></iframe></div>',
          teacher: ''
        },
      ];
      break;
    }
  }

  return list;
}

export const getTeacherList = (university) => {
  let list = [];

  switch (university) {
    case universities.SFU: {
      list = [{
          name: "沈思远",
          title: "速成教育特级经济讲师",
          description: "经济学荣誉学士<br/>\
      国际金融分析师CFA，经济学进入全球前1%<br/>\
      拥有超过20届授课经验，学生人数累计超过3000人"
        },
        {
          name: "皮哥",
          title: "速成教育特级讲师",
          description: "工程专业荣誉学士<br/>\
      仅3年时间完成150个学分，拿到3.9的超高GPA, 毕业时成绩全校第一<br/>\
      5年以上教课经验，学生人数累计超过5000人"
        },
        {
          name: "Danny",
          title: "速成教育特级经济讲师",
          description: "经济学专业荣誉学士<br/>\
      对经济知识点考点熟烂于心；教课至今，不断打破学科第一的记录。<br/>\
      拥有超过15届授课经验，学生人数累计超过1100人"
        },
        {
          name: "Mark",
          title: "速成教育特级经济&金融讲师",
          description: "金融&数学双学位一级荣誉毕业，GPA4.0<br/>\
      曾被麻省理工研究生项目录取，持CFA二级证书<br/>\
      拥有超过30届授课经验，学生人数累计超过3000人"
        },
        {
          name: "俊哥",
          title: "速成教育特级数学讲师&教务总监",
          description: "电子信息工程荣誉学士，GPA3.5<br/>\
      拥有超过18届授课经验，学生人数累计超过1500人"
        },
        {
          name: "Alex",
          title: "速成教育特级经济讲师",
          description: "SFU会计&金融专业荣誉学士<br/> SFU CGPA3.92 超十年的教学生涯，辅导从大一至大四所有的商科必修课程，学生人数累计超过3000人"
        },
        {
          name: "Stacy",
          title: "速成教育高级数学&统计讲师",
          description: "物理专业荣誉学士，GPA3.6<br/>\
      多年的教学沉淀，宽严并济的课堂，巧妙独特的思路，收获了一波又一波好成绩学员<br/>\
      拥有超过15届授课经验，学生人数累计超过1200人"
        },
        {
          name: "Kid",
          title: "速成教育高级商科讲师",
          description: "金融专业荣誉学士<br/>\
      条理清晰，口才出众，考前复习讲义细致入微，学员成绩常年高分领跑同届学生<br/>\
      拥有超过10届授课经验，学生人数累计超过1100人"
        },
        {
          name: "Paul",
          title: "速成教育高级经济讲师",
          description: "金融学荣誉学士，GPA：3.7+<br/>\
      教学风格踏实细致，以知识结构为根本，通过深入浅出的分析让学生对于各类型考点融会贯通<br/>\
      拥有超过10届授课经验，学生人数累计超过900人"},
      {
        name: "Steve", title: "速成教育高级文科讲师",
        description: "金融&运营管理专业荣誉学士，GPA3.0<br/>\
      在针对文科的学习过程，熟练的语言表达能力和独特的传授技巧，让文科变得简单易懂<br/>\
      拥有超过7届授课经验，学生人数累计超过500人"},
      {
        name: "Vicky", title: "速成教育高级文科讲师",
        description: "曾在美国澳大利亚留学多年，双硕士学位 <br/>  拥有商务英语高级口译证书，专业八级<br/>  超强的语言天赋"
      },
      {
        name: "张博", title: "速成教育高级统计讲师",
        description: "物理专业荣誉学士，GPA3.5<br/>\
      讲题突出重点，条例清晰，细致入微，深得各类学生的信赖与喜爱<br/>\
      拥有超过8届授课经验，学生人数累计超过900人"
        },
      ];
      break;
    }
    case universities.UBC: {
      list = [{
          name: "老杜",
          title: "速成教育特级数学讲师",
          description: "数学系荣誉学士<br/>\
      授课即严肃认真又风趣幽默，擅长搭建与训练学生的数学思维，化繁为简<br/>\
      拥有超过8届授课经验，学生人数累计超过1500人"
        },
        {
          name: "Mark",
          title: "速成教育特级经济&金融讲师",
          description: "金融&数学双学位一级荣誉毕业，GPA4.0<br/>\
      曾被麻省理工研究生项目录取，持CFA二级证书<br/>\
      拥有超过30届授课经验，学生人数累计超过3000人"
        },
        {
          name: "俊哥",
          title: "速成教育特级数学讲师&教务总监",
          description: "电子信息工程荣誉学士，GPA3.5<br/>\
      拥有超过18届授课经验，学生人数累计超过1500人"
        },
        {
          name: "Holly",
          title: "速成教育高级经济讲师",
          description: "金融学荣誉学士<br/>\
      擅长总结归纳凌乱的经济学模型理论，帮助学员举一反三，高分通过各项经济学考试<br/>\
      拥有超过9届授课经验，学生人数累计超过600人"
        },
      //   {
      //     name: "Cathy",
      //     title: "速成教育高级经济讲师",
      //     description: "经济专业硕士<br/>\
      // 独创考试题型精简总结，对经典题型讲解透彻，对新题型反应迅速<br/>\
      // 拥有超过12届授课经验，学生人数累计超过800人"
      //   },
        {
          name: "Nemo",
          title: "速成教育高级计算机讲师",
          description: "计算机科学荣誉学士<br/>\
      毕业即获得微软百万年薪邀请，擅长将授课方式与业界应用相结合，带领学员在视野开阔的学习环境下轻松获得4.0的好成绩<br/>\
      拥有超过5届授课经验，学生人数累计超过400人"
        },
        {
          name: "竺海华",
          title: "速成教育高级商科讲师",
          description: "金融学荣誉学士<br/>\
      教学笔记准备详尽，帮助学生稳扎稳打实现成绩飞跃，创造出一个又一个全校第一<br/>\
      拥有超过14届授课经验，学生人数累计超过900人"
        },
        {
          name: "Alex",
          title: "速成教育特级经济讲师",
          description: "SFU会计&金融专业荣誉学士<br/>\
      SFU CGPA3.92 超十年的教学生涯，辅导从大一至大四所有的商科必修课程，学生人数累计超过3000人"
        },
      ];
      break;
    }
    case universities.UTM: {
      list = [{
          name: "火花",
          title: "速成教育环境地理特级讲师",
          description: "教龄：五年以上<br/>\
      累计课次超多1200次<br/>\
      本科在读期间GPA持续保持在3.5以上，带领数千学生在多门大学课程里轻松拿A+；知识点讲解由浅入深，多年的教学经验和零差评的严谨态度更是吸粉无数，成为所有环境地理专业学生的不二选择。"
        },
      //   {
      //     name: "陈东尔",
      //     title: "速成教育经济金融特级讲师&教务总监",
      //     description: "教龄：六年以上<br/>\
      // 金融专业研究生毕业，CFA Level 3 持证人。曾任加拿大最著名前 TOP 5 银行高级分析师，高级数据管理人才。在仅入行教培行业四个月内，就凭借一已之力垄断整个地区多门流量课程。从大一新课到CFA，所有课程一网打尽。最潮的穿搭搭配最严谨负责的态度，让这位经济学领域的大咖成为学生的不二选择。"
      //   },
      //   {
      //     name: "黑黑",
      //     title: "速成教育经济&金融特级讲师",
      //     description: "教龄：四年以上<br/>\
      // 累计学生数量：千人以上<br/>\
      // 作为金融专业荣誉毕业的超级学霸，上至CFA全科，下至低年级经济，超强的学习能力和逻辑清晰的讲课模式，成功把无数高年级的经济金融课，全部教成水课。"
      //   },
        {
          name: "丁然",
          title: "速成教育管理&文科特级讲师",
          description: "教龄：7年<br/>\
      累计学生人数：超过三千人<br/>\
      管理学/文科特级讲师，授课经验极其丰富。超过7年的教课经验，幽默风趣的课堂风格搭配严谨认真的授课态度，教出多届全校最高分，桃李满天下。"
        },
      //   {
      //     name: "宫春吉",
      //     title: "速成教育环境地理高级讲师",
      //     description: "教龄：三年以上<br/>\
      // 累计学生数量：近两千<br/>\
      // 文科届扛把子，最擅长解决各种极度困难 Assignment 的老师，擅长押题以及分析教授出题思路。保姆式手把手教学，有问必答，并且总能结合实际案例让同学Get每一个知识点，好评如潮。"
      //   },
      //   {
      //     name: "张雪婷",
      //     title: "速成教育语言学特级讲师",
      //     description: "教龄：六年以上<br/>\
      // 前 Ling-Lunch语言学团队创始人，所带团队在短期便迅速垄断多伦多大学语言学市场，成为市面上最具竞争力的教育机构。教授课程均百人以上，凭借自身超强的领导力和扎实的学术功底带动了一波又一波的语言学热潮，成功带领近千人成功斩获一个又一个满分的傲人成绩。"
      //   },
        {
          name: "Nick",
          title: "速成教育语言学高级讲师",
          description: "教龄：3年以上<br/>\
      Linguistic 专业毕业，专业课成绩3.7+。有丰富的教学经验，带过超过10个班级，耐心负责。能够教授许多大一和大二的LIN必修课。Lecture 每节都会准时跟课，能够精准的抓住每一个教授的侧重点，带学生进行有针对性的复习。"
        },
        {
          name: "Julie",
          title: "速成教育金融高级讲师",
          description: "教龄：四年<br/>\
      累计学生数量：千人以上<br/>\
      本科金融专业荣誉毕业，四年dean‘s list 毕业CGPA 近3.8。 对教授出题题型，套路，以及对每门课程内容了如指掌，独特的解题思路，押题精准，直击考试重点难点。"
        },
      ];
      break;
    }
    case universities.UTSG: {
      list = [{
          name: "Vincent",
          title: "速成教育高级计算机讲师",
          description: "Computer Science Specialist毕业<br/>\
      曾个学期担任院系TA，参与考试出题<br/>\
      每年累计授课时间数百小时，学生人次过千，带出往届及现届多名CS专业TA以及无数GPA4.0学生"
        },
        {
          name: "Betty",
          title: "速成教育高级数统讲师",
          description: "Specialist in Statistical Science&Actuarial Science Major 专业课GPA3.9+<br/>\
       作为自身实力与教学水平兼具，将所有统计与数学公式、算法、知识、考点融会贯通的数统达人。最善于归纳易考易错知识点和题型来强化知识的运用。帮助学生查缺补漏，绝不放过任何一分。"
        },
        {
          name: "老杜",
          title: "速成教育特级数学讲师",
          description: "数学系荣誉学士<br/>\
      授课即严肃认真又风趣幽默，擅长搭建与训练学生的数学思维，化繁为简<br/>\
      拥有超过8届授课经验，学生人数累计超过1500人"
        },
        {
          name: "黑黑",
          title: "速成教育特级经济&金融讲师",
          description: "教龄：四年以上<br/>\
      累计学生数量：千人以上<br/>\
      作为金融专业荣誉毕业的超级学霸，上至CFA全科，下至低年级经济，超强的学习能力和逻辑清晰的讲课模式，成功把无数高年级的经济金融课，全部教成水课。"
        },
        {
          name: "Dylan",
          title: "速成教育高级数统讲师",
          description: "教龄：三年以上<br/>\
      累计学生人数：五百人以上<br/>\
      数统专业课 CGPA 3.88；数学天赋极强，更是带领超过一半的全程班同学在学校均分并不高的情况下，成功斩获A Level 以上的成绩，并且全程班持续多届保持着超高水准的通过率。"
        },
        {
          name: "老王",
          title: "速成教育特级数统讲师",
          description: "教龄：三年<br/>\
      累计学生数量：300<br/>\
      数学和统计专业荣誉学士，在其本科在读期间专业课全A，通过多届的教学经验 更加会站着学生的立场看待每一个知识点的难易程度 总结出了更加容易让学生理解的思路 快速答疑也让学生的疑惑“不隔夜” 收获了一个又一个A+的优秀学生。"
        },
        {
          name: "Tony",
          title: "速成教育特级数学讲师",
          description: "Mathmatics Specialist,Physics and Apply Math in Finance&Economic Double Specialist荣誉学士<br/>\
      Mathematics Science荣誉硕士<br/>\
      带领八届学生从数通系顺利高分毕业"
        },
        {
          name: "Mark",
          title: "速成教育特级经济&金融讲师",
          description: "教龄：十年以上<br/>\
      累计学生人数：千人以上<br/>\
      金融&数学双学位荣誉学士，在校GPA4.0并数次担任学校TA和讲师。10年丰富授课经验，逻辑清晰，生动有趣的表述足以把所有艰涩难解的知识点化繁为简。带领学生取得高分的同时，轻松让学生培养起适合自己独特的学习方法。"
        },
      ];
      break;
    }
    // case universities.YORK: {
    //   list = [{
    //       name: "轰轰",
    //       title: "速成教育经济特级讲师",
    //       description: "约克Economics本硕连读<br/>\
    //       经济专业课8.87，以全系第一毕业<br/>\
    //       多次获得约克奖学金并曾任职经济学课程TA"
    //     },
    //     {
    //       name: "文娜",
    //       title: "速成教育商科高级讲师",
    //       description: "三年修完约克Commerce专业120学分<br/>\
    //       在读期间获得每年获得约克奖学金，CFA level 1持证人<br/>\
    //       6年商科教学经验，课后答疑极其耐心"
    //     },
    //     {
    //       name: "Edwin",
    //       title: "速成教育经济高级讲师",
    //       description: "约克Financial&Business Economics本科毕业<br/>\
    //   约克Economics研究生毕业<br/>\
    //   Overall GPA:8.53;专业课GPA:8.75<br/>\
    //   拥有CSC,CFA Level II级金融证书<br/>\
    //   连续四年获得LA&PS Continuing Student Scholarships; Dean's Ambassador"
    //     },
    //     {
    //       name: "孙源",
    //       title: "速成教育经济高级讲师",
    //       description: "约克Financial&Business Economics本科毕业<br/>\
    //   Western MFE研究生<br/>\
    //   Summa Cum Laude<br/>\
    //   专业课GPA:8.0,大四专业课程全A+<br/>\
    //   拥有CFA Level I级金融证书"
    //     },
    //     {
    //       name: "恩琪",
    //       title: "速成教育经济高级讲师",
    //       description: "约克经济系本硕连读毕业<br/>\
    //   本科国际留学生排名第一毕业<br/>\
    //   教授特别推荐直升研究生并曾任职约克经济系TA<br/>\
    //   六年教辅经验，多年加拿大金融银行投资理财经验"
    //     },
    //     {
    //       name: "Ling",
    //       title: "速成教育会计高级讲师",
    //       description: "约克ADMS资深导师，约克大学会计专业毕业，GPA7.9<br/>\
    //   在校期间成绩优异连续三年获得TOP15荣誉奖学金<br/>\
    //   19年毕业后进入加拿大最大retailer任职Financial Analyst<br/>\
    //   20年9月CFE successful writer(注册会计师考试)"
    //     },
    //     {
    //       name: "子瑜",
    //       title: "速成教育文科高级讲师",
    //       description: "约克ADMS资深美女导师<br/>\
    //   多年ADMS与SOSC授课经验，擅长文科类课程<br/>\
    //   从事多年律所工作，身经百战的法律实战经验<br/>\
    //   热心负责，极受学生欢迎"
    //     },
    //     {
    //       name: "Elaine",
    //       title: "速成教育经济高级讲师",
    //       description: "约克ECON资深导师，金融数学大牛<br/>\
    //   约克Financial&Business Economics本科毕业<br/>\
    //   舒立克Master of Finance硕士毕业<br/>\
    //   六年教辅经验，学生好评不断"
    //     },
    //   ];
    //   break;
    // }
    case universities.UTSC: {
      list = [{
          name: "Stephan",
          title: "速成教育商科特级讲师",
          description: "五年教学经验，教授上千学员，多门课程斩获百人课堂，UTSC押题王，名副其实的明星讲师。"
        },
        {
          name: "Vincent",
          title: "速成教育计算机高级讲师",
          description: "曾担任A08,A48学校作业唯一出题者，丰富的教学经验，培养出数届多名CS专业TA以及无数4.0学生"
        },
        {
          name: "May",
          title: "速成教育心理高级讲师",
          description: "多大Psychology Specialist Major，在校期间历年Dean’s List获得者，补习授课数百人次，帮助学生取得优异成绩，且以课后答疑严谨认真著称"
        },
        {
          name: "Erick",
          title: "速成教育经济&金融高级讲师",
          description: "ECON+FINANCE元老级讲师，深知教授套路，善于总结归纳高频考点，高分好评收割机"
        },
        {
          name: "火花",
          title: "速成教育环境地理特级讲师",
          description: "教龄：五年以上<br/>\
      累计课次超多1200次<br/>\
      本科在读期间GPA持续保持在3.5以上，带领数千学生在多门大学课程里轻松拿A+；知识点讲解由浅入深，多年的教学经验和零差评的严谨态度更是吸粉无数，成为所有环境地理专业学生的不二选择。"
        },
        {
          name: "丁然",
          title: "速成教育管理&文科特级讲师",
          description: "教龄：7年<br/>\
      累计学生人数：超过三千人<br/>\
      管理学/文科特级讲师，授课经验极其丰富。超过7年的教课经验，幽默风趣的课堂风格搭配严谨认真的授课态度，教出多届全校最高分，桃李满天下。"
        },
      //   {
      //     name: "文娜",
      //     title: "速成教育商科高级讲师",
      //     description: "三年修完约克Commerce专业120学分<br/>\
      //     在读期间获得每年获得约克奖学金，CFA level 1持证人<br/>\
      //     6年商科教学经验，课后答疑极其耐心"
      //   },
      //   {
      //     name: "Bobby",
      //     title: "速成教育环境地理高级讲师",
      //     description: "环境物理/土木工程本硕连读<br/>\
      // 连续三年Dean‘s List 所有环境课程CGPA3.95<br/>\
      // 擅长图文并茂，以故事的形式梳理逻辑关系<br/>\
      // 熟悉考试重点并能帮助学生轻松把握核心知识点"
      //   },
      ];
      break;
    }
  }

  return list;
}



// WEBPACK FOOTER //
// ./src/service/studentLanding.service.js